import React from 'react';
import { Outlet } from 'react-router-dom';
const SimpleLayout = () => {
  return <Outlet></Outlet>;
};
export default SimpleLayout;
